import { Injectable } from '@angular/core';
import { AbstractNavigationService, NavigationOptions } from 'osn-shared';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NavigationService extends AbstractNavigationService {
  protected languageAndCountry$ = new BehaviorSubject<string>('en');

  public async navigate<Option extends keyof NavigationOptions, Args extends Parameters<NavigationOptions[Option]>>(
    option: Option,
    ...args: Args
  ): Promise<boolean> {
    return false;
  }

  public getUrl<Option extends keyof NavigationOptions, Args extends Parameters<NavigationOptions[Option]>>(
    option: Option,
    ...args: Args
  ): string {
    return '';
  }
}
